import * as actionTypes from './constants';
import axios from 'axios';
import { saveState } from '../containers/localStorage';
import { setErrorMessage } from '../messages/actions';
export const createUser = user => {
  return dispatch => {
    dispatch({ type: actionTypes.CREATE_USER_REQUEST });
    return axios
      .post('/createuser', user)
      .then(response => {
        dispatch({
          type: actionTypes.CREATE_USER_SUCCESS,
          user: response.data
        });
      })
      .catch(err => {
        dispatch(setErrorMessage(err.response.data));
        dispatch({ type: actionTypes.CREATE_USER_REJECT, err });
      });
  };
};

export const getUsers = () => {
  return (dispatch, getState) => {
    const hotelId = getState().hotels.selected;
    dispatch({ type: actionTypes.GET_USERS_REQUEST });
    return axios
      .get('/users/' + hotelId)
      .then(response => {
        dispatch({
          type: actionTypes.GET_USERS_SUCCESS,
          users: response.data
        });
      })
      .catch(err => {
        dispatch({ type: actionTypes.GET_USERS_REJECT, err });
      });
  };
};

export const updateUser = user => {
  return (dispatch, getState) => {
    const loggedUser = getState().account.user;
    dispatch({ type: actionTypes.UPDATE_USER_REQUEST });
    return axios
      .put(`/updateuser/${user.userId}`, user)
      .then(() => {
        dispatch({ type: actionTypes.UPDATE_USER_SUCCESS, user });
        if (loggedUser.userId === user.userId) {
          saveState('account', user);
        }
      })
      .catch(err => {
        dispatch({ type: actionTypes.UPDATE_USER_REJECT, err });
      });
  };
};

export const deleteUser = userId => {
  return dispatch => {
    dispatch({ type: actionTypes.DELETE_USER_REQUEST });
    return axios
      .delete('/deleteuser/' + userId)
      .then(() => dispatch({ type: actionTypes.DELETE_USER_SUCCESS, userId }))
      .catch(err => dispatch({ type: actionTypes.DELETE_USER_REJECT, err }));
  };
};

export const selectUser = user => ({
  type: actionTypes.SELECT_USER,
  user
});



// WEBPACK FOOTER //
// ./src/users/actions.js